{
  "deals": {
    "common": {
      "cancel": "Cancel",
      "close": "Close",
      "save": "Save",
      "saving": "Saving…",
      "systemError": "System error. Please try again later.",
      "systemActor": "system",
      "notAssigned": "not assigned"
    },
    "page": {
      "heading": "Deals"
    },
    "view": {
      "kanban": "Kanban",
      "list": "List"
    },
    "actions": {
      "newDeal": "New deal",
      "addProducts": "+ Add products",
      "editProducts": "Edit products",
      "pick": "Pick",
      "createDeal": "Create deal"
    },
    "search": {
      "placeholder": "Search by deal title or lead/merchant"
    },
    "filters": {
      "allStages": "All stages",
      "allSalers": "All sellers"
    },
    "competitiveContextStub": "Competitive context: empty (P12 pending)",
    "fallback": {
      "untitled": "(untitled)",
      "saler": "Seller"
    },
    "pagination": {
      "summary": "Page {{page}} / {{pageCount}} ({{total}} deals)",
      "prev": "Previous",
      "next": "Next"
    },
    "columns": {
      "title": "Title",
      "lead": "Lead / Merchant",
      "value": "Value",
      "stage": "Stage",
      "owner_saler": "Seller",
      "expected_close_date": "Close date",
      "probability_pct": "Probability",
      "last_activity_at": "Last activity"
    },
    "list": {
      "selectAllAria": "Select all visible deals",
      "selectRowAria": "Select deal {{title}}",
      "empty": "No deals match the current filters."
    },
    "stages": {
      "draft": "Draft",
      "pending_approval": "Pending approval",
      "approved": "Approved",
      "sent": "Sent",
      "won": "Won",
      "lost": "Lost",
      "expired": "Expired",
      "rejected": "Rejected",
      "declined": "Declined"
    },
    "kanbanColumns": {
      "draft": "Prospecting",
      "pending_approval": "Proposal",
      "approved": "Negotiation",
      "sent": "Sent",
      "won": "Closed Won",
      "lost": "Closed Lost",
      "expired": "Expired",
      "rejected": "Rejected"
    },
    "kanban": {
      "closePrefix": "Close:",
      "daysInStage": "{{days}}d in stage",
      "confirmStageTitle": "Confirm stage change",
      "confirmStageBody": "Move {{title}} from {{from}} to {{to}}?",
      "confirmBtn": "Confirm",
      "configTooltip": "Configure card",
      "configTitle": "Configure card",
      "colorLabel": "Card background color",
      "labelLabel": "Label (tag)",
      "labelPlaceholder": "e.g. Priority, Hot…",
      "colors": {
        "default": "Default",
        "red": "Red",
        "amber": "Amber",
        "green": "Green",
        "blue": "Blue",
        "purple": "Purple"
      }
    },
    "newModal": {
      "title": "New deal",
      "titleLabel": "Title",
      "titlePlaceholder": "e.g. Q3 staffing quote — Acme Corp",
      "leadLabel": "Lead",
      "leadPlaceholder": "Search lead by name / email / company…",
      "salerLabel": "Owner seller",
      "salerPlaceholder": "Search seller by name / email…",
      "closeDateLabel": "Expected close date",
      "templateLabel": "Template",
      "templatePlaceholder": "(optional) search template…",
      "notesLabel": "Notes",
      "products": "Products",
      "noProducts": "No products picked yet — open the picker to attach catalog items.",
      "discountLabel": "Discount %",
      "taxLabel": "Tax %",
      "grandTotal": "Grand total"
    },
    "productPicker": {
      "title": "Add products",
      "closeBackdropAria": "Close product picker",
      "dialogAria": "Product picker",
      "searchPlaceholder": "Search products by name or SKU",
      "searching": "Searching…",
      "noMatch": "No matching products.",
      "startTyping": "Start typing to search the catalog.",
      "add": "+ Add",
      "chooseVariant": "Choose a variant for {{name}}",
      "noProductsPicked": "No products picked yet.",
      "colProduct": "Product",
      "colQty": "Qty",
      "colUnitPrice": "Unit price",
      "colLineTotal": "Line total",
      "skuPrefix": "SKU",
      "removeAria": "Remove {{name}}",
      "subtotal": "Subtotal:",
      "confirmOne": "Add {{count}} product",
      "confirmMany": "Add {{count}} products",
      "unknownError": "Unknown error"
    },
    "approval": {
      "title": "Approve deal {{id}}",
      "description": "Approval flow follows value thresholds. Manager/Admin can approve when the deal is in “Pending approval”.",
      "name": "Name:",
      "grandTotal": "Grand total:",
      "discount": "Discount:",
      "tax": "Tax:",
      "saler": "Seller:",
      "requiredApprover": "Required approver:",
      "slaText": "Time left before auto-escalation to Admin:",
      "slaEscalated": " (escalated to Admin)",
      "submitHeading": "Submit deal to Manager/Admin for approval",
      "submit": "Submit for approval",
      "submitting": "Submitting…",
      "commentLabel": "Approval note (optional — max 500 characters)",
      "commentPlaceholder": "e.g. OK at this discount level.",
      "approve": "Approve",
      "approving": "Approving…",
      "rejectLabel": "Rejection reason (5–1000 characters — required)",
      "rejectPlaceholder": "e.g. Margin too low — please adjust the discount.",
      "reject": "Reject",
      "rejecting": "Rejecting…",
      "reasonTooShort": "Please enter a reason (at least 5 characters).",
      "toast": {
        "submitSuccessTitle": "Approval request sent",
        "submitSuccessDesc": "Deal {{id}} is awaiting Manager/Admin approval.",
        "submitErrorTitle": "Could not send request",
        "approveSuccessTitle": "Deal approved",
        "approveSuccessDesc": "Deal {{id}} has been approved.",
        "approveErrorTitle": "Could not approve",
        "rejectSuccessTitle": "Deal rejected",
        "rejectSuccessDesc": "Deal {{id}} was rejected. The seller can submit a new version.",
        "rejectErrorTitle": "Could not reject"
      },
      "disabledReason": {
        "notPending": "The deal is in {{stage}} stage — cannot approve/reject.",
        "notApprover": "Only a Manager or Admin can approve deals.",
        "missingPermission": "Your account has not been granted the crm:deals:approve permission.",
        "escalated": "Deal exceeded 48h — escalated to Admin for approval."
      },
      "sla": {
        "overdue": "overdue",
        "minutes": "{{m}} min",
        "hoursMinutes": "{{h}}h {{m}}m"
      }
    },
    "attachments": {
      "title": "Attachments",
      "hint": ": max 25MB/file, 100MB/deal. ClamAV scans after upload.",
      "quotaWarning": "Used {{used}} / 100MB — nearing the deal limit.",
      "dropHint": "Drag & drop files here or click the choose-file button.",
      "choose": "Choose file",
      "uploading": "Uploading…",
      "empty": "No files attached yet.",
      "download": "Download",
      "delete": "Delete",
      "invalidFile": "Invalid file.",
      "scan": {
        "pending": "Scanning…",
        "clean": "Clean",
        "infected": "Infected"
      },
      "toast": {
        "uploadedTitle": "Uploaded",
        "uploadedDesc": "{{filename}} is being scanned for viruses.",
        "uploadErrorTitle": "Upload failed",
        "deletedTitle": "File deleted",
        "deletedDesc": "The attachment has been removed from the deal.",
        "deleteErrorTitle": "Could not delete"
      },
      "error": {
        "empty": "File is empty.",
        "tooLarge": "File exceeds 25MB.",
        "mime": "Format {{type}} is not in the whitelist (PDF/DOC/XLS/JPG/PNG/ZIP).",
        "totalExceeded": "The deal's total attachment size exceeds 100MB."
      }
    },
    "send": {
      "title": "Send quotation {{id}}",
      "description": "Compose the email and (optionally) attach the quotation PDF. The server DOMPurifies the body, prioritizing Resend → SES fallback.",
      "toLabel": "Recipients (To) — comma-separated, 1–5 emails",
      "toPlaceholder": "merchant@example.com",
      "ccLabel": "CC — up to 5 (leave empty if not needed)",
      "ccPlaceholder": "cc1@example.com, cc2@example.com",
      "subjectLabel": "Email subject",
      "languageLabel": "Quotation language",
      "bodyLabel": "Email body (HTML — will be DOMPurified on send)",
      "attachPdf": "Attach the current version's quotation PDF",
      "previewTitle": "PDF preview",
      "generate": "Generate PDF",
      "generating": "Generating…",
      "previewPlaceholder": "Click “Generate PDF” to preview the current version.",
      "iframeTitle": "PDF preview",
      "send": "Send quotation",
      "sending": "Sending…",
      "invalidToList": "Invalid email list.",
      "invalidCcList": "Invalid CC list.",
      "languages": {
        "en": "English (EN)",
        "vi": "Tiếng Việt (VI)",
        "fr": "Français (FR)"
      },
      "toast": {
        "pdfSuccessTitle": "PDF generated",
        "pdfSuccessDesc": "Preview on the right. Click Send to deliver to the customer.",
        "pdfErrorTitle": "Could not generate PDF",
        "sentTitle": "Quotation sent",
        "sentDesc": "Sent via {{provider}} at {{time}}.",
        "sendErrorTitle": "Could not send quotation"
      },
      "error": {
        "minEmails": "At least {{min}} email required.",
        "maxEmails": "At most {{max}} emails.",
        "invalidEmail": "Invalid email: {{item}}"
      }
    },
    "compare": {
      "title": "Compare deal versions",
      "description": "Pick two versions to see the difference in product lines + discount + tax + total.",
      "baseLabel": "Base version (left)",
      "targetLabel": "Compared version (right)",
      "versionOption": "v{{version}} — {{date}}",
      "needBoth": "Select two valid versions to see the differences.",
      "identical": "These two versions are completely identical.",
      "summaryTitle": "Difference summary",
      "discount": "Discount",
      "tax": "Tax",
      "grandTotal": "Grand total",
      "productsTitle": "Product details",
      "skuPrefix": "SKU:",
      "before": "Before",
      "after": "After",
      "qtyPrefix": "Qty",
      "none": "None",
      "status": {
        "added": "Added",
        "removed": "Removed",
        "changed": "Changed",
        "unchanged": "Unchanged"
      }
    },
    "detail": {
      "missingId": "Missing deal ID.",
      "loading": "Loading deal details…",
      "loadError": "Could not load data. Try again later.",
      "back": "Back to deals list",
      "tabsAria": "Deal detail sections",
      "tabs": {
        "overview": "Overview",
        "versions": "Versions",
        "activity": "Activity",
        "documents": "Documents"
      },
      "header": {
        "approvalPrefix": "Approval:",
        "lead": "Lead:",
        "saler": "Seller:",
        "generateSend": "Generate & send quotation",
        "sendEmail": "Send email",
        "approve": "Approve deal",
        "clone": "Clone",
        "invalidateLink": "Invalidate public link"
      },
      "toast": {
        "cloneSuccessTitle": "Deal cloned",
        "cloneSuccessDesc": "New deal: {{id}}.",
        "cloneErrorTitle": "Could not clone"
      },
      "overview": {
        "productsTitle": "Products",
        "nonDraftNote": "The deal has left Draft — it can only be edited by creating a new version (POST /versions).",
        "noProducts": "No products in this deal yet.",
        "qty": "Qty",
        "unitPrice": "Unit price",
        "lineTotal": "Line total",
        "skuPrefix": "SKU",
        "summaryTitle": "Summary",
        "subtotal": "Subtotal",
        "discountPct": "Discount %",
        "taxPct": "Tax %",
        "discountLine": "Discount (-)",
        "taxLine": "Tax (+)",
        "grandTotal": "Grand total",
        "expiryLabel": "Expected close date (expiry)",
        "termsLabel": "Terms",
        "notesLabel": "Internal notes",
        "save": "Save changes",
        "saveSuccessTitle": "Changes saved",
        "saveSuccessDesc": "Deal {{id}} has been updated.",
        "saveErrorTitle": "Could not save deal"
      },
      "versions": {
        "title": "Versions ({{count}})",
        "compare": "Compare versions",
        "tooMany": ": the deal already has {{count}} versions — consider creating a new deal instead of continuing to revise.",
        "empty": "The deal has no snapshot versions yet. One appears the first time “Generate PDF” runs.",
        "linkRevoked": "Link revoked {{date}}"
      },
      "activity": {
        "loading": "Loading activity…",
        "loadError": "Could not load activity.",
        "title": "Activity",
        "subtitle": "Log filtered to the current deal.",
        "empty": "No activity recorded yet.",
        "actorPrefix": "Actor:"
      },
      "documents": {
        "pdfTitle": "Quotation PDF by version",
        "pdfSubtitle": "Each snapshot version has one PDF — links open in a new tab.",
        "pdfEmpty": "No version has been snapshotted yet.",
        "openPdf": "Open PDF"
      },
      "conflict": {
        "title": "Deal was changed",
        "description": "Another user just updated this deal. Please reload to see the latest version before saving.",
        "dismiss": "Dismiss",
        "reload": "Reload"
      },
      "invalidate": {
        "title": "Invalidate public link",
        "description": "The current link UUID will return 410 Gone. The system generates a new UUID and records the activity.",
        "reasonLabel": "Reason (optional — shown in the activity log)",
        "reasonPlaceholder": "e.g. link was forwarded unintentionally",
        "successTitle": "Old link invalidated",
        "successDesc": "New public link: {{uuid}}",
        "processing": "Processing…",
        "confirm": "Invalidate link"
      }
    }
  },
  "quotationBlocks": {
    "header": {
      "primaryColor": "Primary color"
    },
    "footer": {
      "validityPlaceholder": "Quotation valid until {{deal.valid_until}} · Issued by {{deal.seller.name}}"
    },
    "terms": {
      "defaultPlaceholder": "Payment within 15 days. Quote valid for 30 days. {{deal.notes}}"
    }
  },
  "leads": {
    "common": {
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "close": "Close",
      "loading": "Loading…",
      "actionSuccess": "Action successful.",
      "systemError": "System error. Please try again later.",
      "loadError": "Failed to load data. Try again later.",
      "empty": "(empty)",
      "none": "—"
    },
    "stages": {
      "new": "New",
      "contacted": "Contacted",
      "qualified": "Qualified",
      "negotiation": "Negotiation",
      "converted": "Converted",
      "lost": "Lost",
      "archived": "Archived"
    },
    "list": {
      "title": "Leads",
      "viewKanban": "Kanban",
      "viewList": "List",
      "importCsv": "Import CSV",
      "newLead": "New lead",
      "searchPlaceholder": "Search by name / email / company",
      "allStages": "All stages",
      "allSalers": "All sellers",
      "pageInfo": "Page {{page}} of {{pageCount}} ({{total}} leads)",
      "prev": "Previous",
      "next": "Next"
    },
    "quickView": {
      "titleFallback": "Lead details",
      "email": "Email",
      "company": "Company",
      "stage": "Stage",
      "label": "Label",
      "tags": "Tags",
      "notes": "Notes",
      "notFound": "Lead not found.",
      "openFull": "Open detail page"
    },
    "table": {
      "colName": "Name",
      "colEmail": "Email",
      "colCompany": "Company",
      "colStage": "Stage",
      "colSaler": "Seller",
      "colTags": "Tags",
      "selectAll": "Select all leads",
      "selectOne": "Select {{name}}",
      "empty": "No leads."
    },
    "kanban": {
      "confirmTitle": "Confirm stage change",
      "moveConfirm": "Move \"{{name}}\" from {{from}} to {{to}}?",
      "confirm": "Confirm",
      "cardConfigTitle": "Card settings",
      "cardBg": "Card background colour",
      "cardLabel": "Label (tag)",
      "cardLabelPlaceholder": "e.g. Priority, Hot…",
      "colors": {
        "default": "Default",
        "red": "Red",
        "amber": "Amber",
        "green": "Green",
        "blue": "Blue",
        "purple": "Purple"
      }
    },
    "bulk": {
      "selected": "{{count}} selected",
      "reassign": "Reassign",
      "changeStage": "Change stage",
      "delete": "Delete",
      "exportCsv": "Export CSV",
      "clear": "Clear",
      "confirmDelete": "Delete {{count}} selected leads?",
      "reassignTitle": "Reassign {{count}} leads to a seller",
      "changeStageTitle": "Change stage for {{count}} leads",
      "stagePlaceholder": "Select stage",
      "exportQueued": "Exporting CSV — you will get the file when it is done.",
      "actionFailed": "Bulk action failed",
      "permissionHint": "Your account is missing the CRM lead permission for this action."
    },
    "csv": {
      "title": "Import leads from CSV",
      "fields": {
        "name": "Name *",
        "email": "Primary email *",
        "phone": "Phone",
        "company": "Company",
        "source": "Source",
        "tags": "Tags"
      },
      "step1": "1. Upload",
      "step2": "2. Mapping",
      "step3": "3. Preview",
      "step4": "4. Progress",
      "step5": "5. Report",
      "fileTooLarge": "File exceeds 10MB limit.",
      "selected": "Selected: {{name}}",
      "dropzone": "Drag CSV here or click to browse",
      "uploadHint": "Max 10MB / 5,000 rows. Required columns: Name + Primary email.",
      "mappingHint": "Map CSV columns → Lead fields. Auto-detected where possible.",
      "skip": "— skip —",
      "progressNote": "Import job queued. Progress will stream via WebSocket.",
      "reportComplete": "Import complete.",
      "imported": "Imported: {{count}}",
      "skipped": "Skipped (duplicate email): {{count}}",
      "errors": "Errors: {{count}}",
      "downloadErrorCsv": "Download error CSV",
      "next": "Next",
      "startImport": "Start import",
      "done": "Done",
      "exportInProgress": "Exporting CSV — you will receive the file when it is ready.",
      "parseFailed": "Could not read any columns from this file. Save it as CSV (comma, semicolon or tab separated) and try again — an .xlsx workbook has to be exported to CSV first.",
      "notCsvFile": "Only .csv files can be imported. In Excel use File → Save As → CSV."
    },
    "create": {
      "title": "Create new lead",
      "subtitle": "Enter lead details. Email must be unique.",
      "name": "Name *",
      "emailPrimary": "Primary email *",
      "company": "Company",
      "source": "Source",
      "notes": "Notes",
      "sources": {
        "manual": "Manual entry",
        "csv_import": "CSV import",
        "auto_registration": "Self-registration",
        "referral": "Referral"
      },
      "creating": "Creating...",
      "submit": "Create lead",
      "errRequired": "Name and email are required",
      "errFail": "Failed to create lead"
    },
    "activity": {
      "types": {
        "stage_change": "Stage change",
        "note": "Note",
        "call": "Call",
        "meeting": "Meeting",
        "email_sent": "Email sent",
        "email_clicked": "Email clicked",
        "version": "Quote version",
        "approval": "Quote approval",
        "contacted": "Contacted",
        "attachment": "Attachment",
        "quotation_sent": "Quote sent"
      },
      "regionAria": "Lead activity timeline",
      "filterLabel": "Filter by event type:",
      "clearFilter": "Clear filter",
      "loading": "Loading activity…",
      "empty": "No activity yet.",
      "by": "By: {{actor}}",
      "loadMore": "Load more ({{count}})",
      "subject": "Subject: {{subject}}",
      "manualTypes": {
        "note": "Note",
        "call": "Call",
        "meeting": "Meeting"
      },
      "formType": "Activity type",
      "duration": "Duration (minutes)",
      "body": "Content",
      "bodyPlaceholder": "Summarize the call/meeting or an internal note…",
      "followup": "Follow-up",
      "repeat": "Repeat",
      "occurrences": "Next recurring schedule:",
      "saveActivity": "Save activity",
      "errBodyRequired": "Please enter content (body) before saving.",
      "savedTitle": "Action successful.",
      "savedDesc": "New activity recorded in the timeline.",
      "saveFailTitle": "Could not save activity",
      "rrulePresets": {
        "none": "No repeat",
        "daily": "Daily",
        "weekly": "Weekly",
        "biweekly": "Every two weeks",
        "monthly": "Monthly"
      }
    },
    "merge": {
      "title": "Merge duplicate leads",
      "description": "The current lead will be archived (soft-deleted) and all activities / deals / notes will be moved to the target lead. The target lead's primary email is preserved.",
      "fields": {
        "name": "Name",
        "company": "Company",
        "phones": "Phone numbers",
        "tags": "Tags",
        "notes": "Notes",
        "custom_fields": "Custom fields"
      },
      "targetIdLabel": "Target lead ID (will be kept)",
      "targetIdPlaceholder": "lead_xxx or friendly_id",
      "loadTarget": "Load data",
      "sameLeadError": "Cannot merge a lead with itself.",
      "loadingTarget": "Loading target lead…",
      "targetNotFound": "Target lead not found.",
      "sourceCard": "Source lead (will be archived)",
      "targetCard": "Target lead (will be kept)",
      "noConflict": "No field conflicts — all activities / deals / notes will be merged into the target lead, keeping its existing fields.",
      "conflictHint": "Conflicting fields — choose which side to keep:",
      "fieldPickerAria": "Field picker",
      "colField": "Field",
      "colSource": "Source lead",
      "colTarget": "Target lead",
      "confirm": "Confirm merge",
      "merging": "Merging…",
      "selectTargetFirst": "Please select a target lead first.",
      "mergedDesc": "Merged lead {{source}} into {{target}}."
    },
    "detail": {
      "missingId": "Missing lead ID.",
      "loading": "Loading lead details…",
      "back": "Back to leads list",
      "tabs": {
        "info": "Info",
        "activity": "Activity",
        "deals": "Deals",
        "merchant": "Merchant",
        "files": "Files"
      },
      "tabsAria": "Lead detail sections",
      "company": "Company: {{company}}",
      "email": "Email: {{email}}",
      "phone": "Phone: {{phones}}",
      "assignee": "Assignee:",
      "unassigned": "Unassigned",
      "convertBtn": "Convert to merchant",
      "convertedBtn": "Converted",
      "mergeBtn": "Merge duplicate lead",
      "archiveBtn": "Archive",
      "archivedBtn": "Archived",
      "basicInfo": "Basic info",
      "customFields": "Custom fields",
      "customFieldsHint": "Enter as a JSON object. The server validates the schema.",
      "fieldName": "Name",
      "fieldStage": "Stage",
      "fieldAssignee": "Assignee",
      "assigneePlaceholder": "Find seller by name / email…",
      "fieldTags": "Tags (comma-separated)",
      "tagsPlaceholder": "vip, q2-priority",
      "fieldNotes": "Internal notes",
      "saveChanges": "Save changes",
      "savedDesc": "Lead {{id}} updated.",
      "saveFailTitle": "Could not save lead",
      "customFieldsInvalid": "custom_fields must be a JSON object.",
      "deals": {
        "loading": "Loading deals…",
        "empty": "This lead has no linked deals yet.",
        "colDeal": "Deal",
        "colStage": "Stage",
        "colValue": "Value",
        "colExpiry": "Expiry",
        "noTitle": "(no title)"
      },
      "files": {
        "loading": "Loading files…",
        "empty": "No files yet. Files are attached to the deals linked to this lead.",
        "dealPrefix": "Deal: {{deal}}",
        "fileFallback": "file"
      },
      "merchant": {
        "notConvertedTitle": "Not converted",
        "notConvertedDesc": "This lead has not been converted to a merchant. Click the 'Convert to merchant' button in the action bar to start the onboarding flow.",
        "convertedTitle": "Converted merchant",
        "convertedBody": "This lead has been converted to merchant",
        "openMerchant": "Open merchant page →"
      },
      "archive": {
        "title": "Archive lead",
        "description": "Lead {{id}} will be archived (soft-delete). You can restore it from the archive page.",
        "archiving": "Archiving…"
      },
      "convert": {
        "title": "Convert lead to merchant",
        "descWithEmail": "Lead {{id}} will be converted to a merchant. A login account will be created and an invitation email will be sent.",
        "descNoEmail": "Lead {{id}} will be converted to a merchant. A login account will be created (no email sent).",
        "descIneligible": "Lead {{id}} is at the {{stage}} stage. Conversion is only allowed when the stage is \"Qualified\" or \"Negotiation\".",
        "sendEmail": "Send login invitation email to the new merchant",
        "converting": "Converting…",
        "confirm": "Convert",
        "eligibilityError": "Conversion is only allowed when the stage is \"Qualified\" or \"Negotiation\".",
        "successTitle": "Converted to merchant",
        "successDesc": "Merchant {{id}} has been created.",
        "archiveSuccessDesc": "Lead {{id}} archived."
      }
    }
  },
  "settings": {
    "page": {
      "heading": "Sales Settings",
      "description": "Configure CRM for the entire sales pipeline — approval thresholds, custom fields, loss reasons, quotation templates, admin digest, Lark / ICS integrations.",
      "tablistAria": "Sales settings tabs"
    },
    "tabs": {
      "general": "General",
      "customFields": "Custom Fields",
      "lossReasons": "Loss Reasons",
      "templates": "Quotation Templates",
      "digest": "Digest",
      "integrations": "Integrations"
    },
    "common": {
      "save": "Save",
      "saving": "Saving…",
      "undo": "Undo",
      "add": "+ Add",
      "adding": "Adding…",
      "delete": "Delete",
      "setDefault": "Set default",
      "defaultBadge": "Default",
      "saveFailed": "Could not save",
      "setDefaultSuccess": "Default set",
      "setDefaultFailed": "Could not set default",
      "label": "Label",
      "enable": "Enable"
    },
    "general": {
      "validation": {
        "number": "Must be a number",
        "integer": "Must be an integer",
        "nonNegative": "Cannot be negative",
        "tooLarge": "Too large",
        "minDays": "Minimum 1 day",
        "maxDays": "Maximum 90 days"
      },
      "approval": {
        "title": "Approval thresholds",
        "description": "USD (cents) thresholds that auto-route a quote to the matching approval level. Quote ≤ Seller limit → auto-approve. Above Seller limit → Manager. Above Manager → Admin.",
        "salerLimit": "Seller auto-approve limit (cents)",
        "managerLimit": "Manager limit (cents)",
        "adminLimit": "Admin limit (cents)"
      },
      "reminders": {
        "title": "Reminder & stale thresholds",
        "description": "Lead inactive reminder days is the number of days a Lead has no activity before a reminder is sent. Deal expiry and stale-conversation thresholds are fixed per CONTEXT.",
        "leadInactive": "Lead inactive reminder (days)"
      },
      "fixedInfo": {
        "dealExpiryLabel": "Deal expiry reminder:",
        "dealExpiryBefore": "7 days before ",
        "dealExpiryAfter": "(fixed,).",
        "staleLabel": "Stale-conversation thresholds:",
        "staleValue": "3d / 7d / 14d (fixed,)."
      },
      "saveSuccessTitle": "Saved",
      "saveSuccessDesc": "General settings have been updated.",
      "loading": "Loading General settings",
      "loadError": "Could not load General settings."
    },
    "customFields": {
      "loading": "Loading custom fields",
      "loadError": "Could not load custom fields.",
      "addedSuccess": "Custom field added",
      "addFailed": "Could not add",
      "reorderSuccess": "Order updated",
      "reorderFailed": "Could not save order",
      "deletedSuccess": "Custom field deleted",
      "deleteFailed": "Could not delete",
      "listTitle": "Custom fields",
      "listDescription": "Manage custom fields for the Lead entity. Drag and drop to reorder (display position on the Lead form).",
      "empty": "No custom fields yet.",
      "dragTitle": "Drag to reorder",
      "requiredBadge": "Required",
      "addTitle": "Add custom field",
      "addDescription": "The field will appear on the Lead form at its assigned position.",
      "labelPlaceholder": "e.g. Industry",
      "typeLabel": "Type",
      "requiredCheckbox": "Required",
      "types": {
        "text": "Text",
        "number": "Number",
        "dropdown": "Dropdown",
        "date": "Date",
        "checkbox": "Checkbox"
      }
    },
    "digest": {
      "saveSuccess": "Digest schedule saved",
      "loading": "Loading Digest config",
      "loadError": "Could not load Digest config.",
      "cardTitle": "Admin digest",
      "cardDescription": "Summary email sent to Admin with funnel + win/loss highlights. Choose a cadence, or turn it off if not needed.",
      "enableLabel": "Enable",
      "enableCheckbox": "Enable Admin digest",
      "cadenceLabel": "Cadence",
      "cadence": {
        "dailyMorning": "Daily — 8:00 server time",
        "weeklyMonday": "Weekly — Monday morning"
      }
    },
    "integrations": {
      "saveSuccess": "Integrations saved",
      "loading": "Loading Integrations",
      "loadError": "Could not load Integrations.",
      "validation": {
        "urlTooLong": "URL too long",
        "urlHttps": "Webhook URL must start with https://"
      },
      "missingWebhookTitle": "Missing webhook URL",
      "missingWebhookDesc": "Enter a webhook URL before testing.",
      "testSuccessTitle": "Lark webhook works",
      "testSuccessDesc": "Received a 2xx response from Lark.",
      "testFailedTitle": "Lark test failed",
      "lark": {
        "title": "Lark Bot",
        "description": "Send CRM notifications (new lead, deal won, escalation) to a Lark group via incoming webhook. Test before enabling.",
        "enableLabel": "Enable Lark Bot",
        "webhookLabel": "Webhook URL",
        "test": "Test webhook",
        "testing": "Sending test…"
      },
      "ics": {
        "title": "ICS calendar export",
        "description": "When enabled, each Seller gets an ICS feed URL (subscribe-by-URL) to pull deal expiry + lead reminders into Google / Outlook calendar.",
        "enableLabel": "Enable ICS feed"
      }
    },
    "lossReasons": {
      "addedSuccess": "Loss reason added",
      "addFailed": "Could not add",
      "reorderSuccess": "Order updated",
      "reorderFailed": "Could not save order",
      "actionFailed": "Action failed",
      "loading": "Loading loss reasons",
      "loadError": "Could not load loss reasons.",
      "listTitle": "Loss reasons",
      "listDescription": "The reasons shown in the dropdown when closing a Lead as Lost. The default seed (Budget / Competitor / No response / Not qualified / Other) cannot be deleted — only archived.",
      "empty": "No loss reasons yet.",
      "defaultSeedBadge": "Default seed",
      "archivedBadge": "Archived",
      "restore": "Restore",
      "archive": "Archive",
      "addTitle": "Add loss reason",
      "addDescription": "A new reason appears at the end of the list; use drag and drop to reposition after creating.",
      "labelPlaceholder": "e.g. Pricing too high"
    },
    "templates": {
      "deletedSuccess": "Template deleted",
      "deleteFailed": "Could not delete",
      "loading": "Loading quotation templates",
      "loadError": "Could not load templates.",
      "title": "Quotation templates",
      "description": "The block editor for each template lives on its own page (task-55). Each locale (EN/VI/FR) can have one default template; quotes created from a Lead use the default template for the Merchant's locale.",
      "newTemplate": "+ New template",
      "empty": "No templates yet.",
      "deleteDefaultTooltip": "Set another template as default before deleting."
    },
    "editor": {
      "saveSuccess": "Template saved",
      "saveFailed": "Could not save template",
      "previewFailed": "Preview error",
      "setDefaultSuccess": "Default set",
      "setDefaultFailed": "Could not set default",
      "loading": "Loading template",
      "loadError": "Could not load template.",
      "namePlaceholder": "Template name",
      "untitledTemplate": "Untitled template",
      "rendering": "Rendering…",
      "refreshPreview": "Refresh preview",
      "setDefault": "Set default",
      "saving": "Saving…",
      "save": "Save template",
      "productTableTitle": "Product table",
      "productTableBody": "Server-rendered from deal items: SKU · Name · Unit · Quantity · Unit price · Amount. Fixed layout.",
      "summaryTitle": "Summary",
      "summaryTokensLabel": "Auto-injected tokens:",
      "variablesTitle": "Variables",
      "variablesHelp": "Click to copy a token. Paste into the Terms / Footer field.",
      "copiedTitle": "Token copied",
      "pdfPreviewTitle": "PDF preview",
      "pdfPreviewSubtitle": "Sample deal · auto-refresh on save",
      "iframeTitle": "Quotation PDF preview",
      "previewEmpty": "Click “Refresh preview” to render the PDF with a sample deal.",
      "conflictTitle": "Template was changed",
      "conflictBody": "Another admin just saved this template. Reload to see the new snapshot and re-apply your changes?",
      "close": "Close",
      "reload": "Reload",
      "tokenDesc": {
        "leadFullName": "Lead full name",
        "leadCompany": "Lead company",
        "dealId": "Deal ID",
        "dealValue": "Deal monetary value",
        "dealValidUntil": "Deal validity date",
        "dealSalerName": "Seller full name",
        "dealNotes": "Deal-specific notes",
        "productsTable": "Auto product table",
        "subtotal": "Subtotal",
        "discount": "Discount amount",
        "tax": "Tax amount",
        "total": "Grand total"
      }
    }
  },
  "benefits": {
    "page": {
      "title": "Merchant Benefits",
      "description": "Grant benefits to merchants that reach a GMV milestone.",
      "salerReadonly": "Seller has read-only access."
    },
    "tabs": {
      "pending": "Pending",
      "granted": "Granted"
    },
    "table": {
      "merchant": "Merchant",
      "tier": "Tier",
      "benefitType": "Benefit type",
      "description": "Description",
      "status": "Status",
      "action": "Action"
    },
    "actions": {
      "grant": "Grant"
    },
    "status": {
      "pending": "Pending",
      "granted": "Granted",
      "revoked": "Revoked"
    },
    "benefitTypes": {
      "pricing_tier": "Pricing tier",
      "wallet_credit": "Wallet credit",
      "badge": "Badge",
      "custom": "Custom"
    },
    "empty": {
      "pending": "No merchants are waiting for a benefit grant.",
      "granted": "No benefits have been granted yet."
    },
    "loading": "Loading data…",
    "pagination": {
      "info": "Page {{page}} / {{pageCount}} ({{total}} benefits)",
      "prev": "Previous",
      "next": "Next"
    },
    "toast": {
      "success": "Action completed successfully."
    },
    "modal": {
      "title": "Grant benefit",
      "merchantLabel": "Merchant",
      "tierLabel": "Tier",
      "benefitTypeLabel": "Benefit type",
      "amountLabel": "Amount (cents)",
      "amountPlaceholder": "50000",
      "descriptionLabel": "Description ({{count}}/500)",
      "descriptionPlaceholder": "Bronze rebate Apr 2026",
      "expiresLabel": "Expiry (optional)",
      "cancel": "Cancel",
      "submit": "Grant",
      "submitting": "Processing…",
      "errors": {
        "description": "Description must be between 2 and 500 characters.",
        "amount": "Wallet credit requires an amount (in cents) ≥ 1.",
        "invalidDate": "Invalid expiry date."
      }
    }
  },
  "groups": {
    "page": {
      "title": "Seller Groups",
      "description": "Manage Seller / Manager groups — 2-level hierarchy."
    },
    "actions": {
      "create": "+ Create group",
      "view": "View",
      "edit": "Edit",
      "assignSaler": "Assign seller",
      "addSubGroup": "+ Sub-group",
      "delete": "Delete"
    },
    "common": {
      "cancel": "Cancel"
    },
    "tree": {
      "empty": "No Seller Group yet. Click \"Create group\" to start.",
      "level": "Lv {{level}}",
      "memberCount": "{{count}} members",
      "subGroupCount": "{{count}} sub-group",
      "deleteBlockedChildren": "Cannot delete: the group still has sub-groups.",
      "deleteBlockedMembers": "Cannot delete: the group still has {{count}} members.",
      "deleteTitle": "Delete group"
    },
    "form": {
      "nameLabel": "Group name",
      "managerLabel": "Manager",
      "managerPlaceholder": "Search manager by name or email…",
      "managerHint": "Leave empty if no manager is assigned yet.",
      "subGroupHint": "Create a sub-group (Level 2) under the parent group:",
      "submitting": "Saving…",
      "create": "Create group",
      "update": "Update",
      "error": "An error occurred while saving the group."
    },
    "dialog": {
      "createTitle": "New group",
      "editTitle": "Edit group"
    },
    "confirm": {
      "delete": "Delete group \"{{name}}\"?",
      "removeMember": "Remove \"{{name}}\" from group \"{{group}}\"?"
    },
    "assign": {
      "title": "Assign seller to \"{{name}}\"",
      "description": "Search seller by name or email.: existing leads stay with the old team and must be reassigned separately.",
      "placeholder": "Search seller by name / email…",
      "submit": "Assign"
    },
    "members": {
      "title": "Members — {{name}}",
      "countLevel": "{{count}} members · Lv {{level}}",
      "close": "Close",
      "loading": "Loading…",
      "empty": "The group has no members yet.",
      "remove": "Remove"
    },
    "loading": "Loading data…"
  },
  "merchants": {
    "list": {
      "title": "Merchants — Customer Health",
      "subtitle": "Sorted by health score ascending (critical first).",
      "searchPlaceholder": "Search merchant…",
      "healthFilterLabel": "Health:",
      "tierFilterLabel": "KPI tier:",
      "loading": "Loading data…",
      "empty": "No merchants match the filter.",
      "selectRowAria": "Select {{name}}",
      "columns": {
        "merchant": "Merchant",
        "tier": "Tier",
        "health": "Health",
        "score": "Score",
        "lastOrder": "Last order"
      },
      "bulk": {
        "selectedCount": "{{count}} merchant(s) selected",
        "clear": "Clear selection",
        "grantBenefit": "Bulk grant benefit",
        "grantBenefitTooltip": "Grant the same benefit to multiple merchants — see the full flow at /admin/sales/benefits."
      }
    },
    "health": {
      "stateLabels": {
        "healthy": "Healthy",
        "at_risk": "At risk",
        "critical": "Critical",
        "churned": "Churned"
      },
      "notComputedTooltip": "Health score not computed yet. The RFM cron runs nightly at 02:00 UTC.",
      "breakdown": "Breakdown: {{text}}",
      "weights": "Weights: R=40, F=30, M=20, E=10."
    },
    "tierLabels": {
      "bronze": "Bronze",
      "silver": "Silver",
      "gold": "Gold",
      "platinum": "Platinum"
    },
    "trendLabels": {
      "improving": "Improving",
      "declining": "Declining",
      "stable": "Stable"
    },
    "drawer": {
      "close": "Close",
      "healthScoreLabel": "Health score:",
      "scoreComponents": "Score components",
      "maxPoints": "max {{weight}} pts",
      "detailNote": "Per-component score details + order history are available in the full profile.",
      "tier": "Tier",
      "lastOrder": "Last order",
      "scoreUpdated": "Score updated",
      "viewFullProfile": "View full profile",
      "dimensions": {
        "R": "Recency (latest order)",
        "F": "Frequency (order cadence)",
        "M": "Monetary (GMV)",
        "E": "Engagement"
      }
    }
  },
  "reports": {
    "periods": {
      "week": "Week",
      "month": "Month",
      "quarter": "Quarter",
      "year": "Year"
    },
    "periodAria": "Period",
    "stageLabels": {
      "new": "New",
      "qualified": "Qualified",
      "proposal": "Proposal",
      "negotiation": "Negotiation",
      "closed_won": "Closed won",
      "closed_lost": "Closed lost"
    },
    "filters": {
      "salerId": "Seller ID",
      "groupId": "Group ID",
      "allPlaceholder": "(all)"
    },
    "export": {
      "csv": "Export CSV",
      "excel": "Export Excel",
      "jobCreatedTitle": "Created {{format}} job",
      "jobCreatedDesc": "Email will be sent when complete (~{{seconds}}s).",
      "errorTitle": "Could not create export"
    },
    "funnel": {
      "title": "Lead Funnel",
      "subtitle": "Lead distribution by stage + conversion rate between steps.",
      "overallConversion": "Overall conversion rate",
      "stageCount": "Stage count",
      "distributionByStage": "Distribution by stage",
      "chartEmpty": "No funnel data yet.",
      "tableEmpty": "No data.",
      "columns": {
        "stage": "Stage",
        "count": "Count",
        "conversionNext": "% conversion to next step"
      }
    },
    "winLoss": {
      "title": "Win / Loss",
      "subtitle": "Closed-won vs closed-lost deals over time + win rate + loss-reason breakdown.",
      "winRate": "Win rate",
      "won": "Won",
      "lost": "Lost",
      "chartTitle": "Won vs Lost",
      "chartEmpty": "No data yet.",
      "wonLabel": "Won",
      "lostLabel": "Lost",
      "lossReasonsTitle": "Loss reasons",
      "reasonsEmpty": "No lost deals in this range.",
      "columns": {
        "reason": "Reason",
        "dealCount": "Deal count"
      }
    },
    "hub": {
      "title": "Sales Reports",
      "subtitle": "Funnel / Win-Loss / Pipeline / GMV reports. Click a card to see details.",
      "cardsAria": "Reports",
      "pipelineSummaryAria": "Pipeline summary",
      "activePipeline": "Active pipeline",
      "grandPipeline": "Grand pipeline",
      "forecastWeighted": "Forecast (weighted)",
      "chartEmpty": "No active deals."
    },
    "cards": {
      "funnel": {
        "label": "Lead Funnel",
        "description": "Lead stage distribution + per-stage conversion %."
      },
      "win-loss": {
        "label": "Win / Loss",
        "description": "Closed-won vs closed-lost deals over time + win rate."
      },
      "pipeline": {
        "label": "Pipeline",
        "description": "Active deal value sums per stage + forecast (probability-weighted)."
      },
      "gmv": {
        "label": "GMV",
        "description": "GMV by seller / merchant / category + CSV export."
      }
    }
  },
  "shared": {
    "autocomplete": {
      "placeholder": "Search by name / email…",
      "searching": "Searching…",
      "noResults": "No results"
    },
    "userChip": {
      "unassigned": "Unassigned",
      "fallbackName": "User {{idTail}}"
    }
  },
  "calendar": {
    "title": "My calendar",
    "subtitle": "Follow-ups + deal expiries + quotations sent. Click \"Reschedule\" to move an event.",
    "newFollowup": "+ New follow-up",
    "viewModeAria": "View mode",
    "gridAria": "Grid",
    "loadError": "Failed to load calendar.",
    "noEvents": "No events",
    "cancel": "Cancel",
    "views": {
      "week": "Week",
      "day": "Day"
    },
    "eventKinds": {
      "follow_up": "Follow-up",
      "deal_expire": "Deal expiring",
      "quotation_sent": "Quotation sent"
    },
    "reschedule": {
      "title": "Reschedule",
      "dateTimeLabel": "New date and time",
      "saving": "Saving…",
      "confirm": "Confirm"
    },
    "create": {
      "title": "New follow-up",
      "description": "Create a new lead with a contact milestone — it will show on the calendar.",
      "nameLabel": "Name *",
      "emailLabel": "Email *",
      "contactLabel": "Contact milestone *",
      "creating": "Creating…",
      "submit": "Create"
    },
    "toast": {
      "createSuccess": "Follow-up created",
      "createFailTitle": "Could not create",
      "rescheduleSuccessTitle": "Rescheduled",
      "rescheduleSuccessDesc": "The event has been rescheduled.",
      "rescheduleFailTitle": "Could not reschedule",
      "invalidFormatTitle": "Invalid format",
      "invalidFormatDesc": "Please pick a valid date/time."
    },
    "regenerate": {
      "create": "Generate new ICS URL",
      "creating": "Generating…",
      "copyUrl": "Copy URL",
      "overlapNote": "The old URL keeps working until {{date}}.",
      "toast": {
        "createdTitle": "New URL generated",
        "createdDesc": "The old URL keeps working for 7 days to avoid disruption.",
        "createFailTitle": "Could not generate new URL",
        "copiedTitle": "Copied",
        "copiedDesc": "The new ICS URL has been copied.",
        "copyFailTitle": "Could not copy",
        "copyFailDesc": "The browser denied clipboard access."
      }
    }
  },
  "gmvReport": {
    "title": "GMV Report",
    "subtitle": "GMV by seller / merchant / category / period. Cached 5 min (BE Redis).",
    "refresh": "Refresh",
    "exportCsv": "Export CSV",
    "filtersAria": "Filters",
    "chartTitle": "GMV {{group}}",
    "noDataRange": "No data in this time range.",
    "noData": "No data.",
    "filters": {
      "dateFrom": "From date",
      "dateTo": "To date",
      "groupBy": "Group by",
      "chart": "Chart"
    },
    "groupBy": {
      "saler": "By seller",
      "merchant": "By merchant",
      "category": "By category",
      "day": "By day",
      "month": "By month"
    },
    "chartType": {
      "bar": "Bar",
      "line": "Line"
    },
    "kpi": {
      "gross": "Gross GMV",
      "refunded": "Refunded",
      "net": "Net GMV"
    },
    "table": {
      "orders": "Orders",
      "gross": "Gross GMV",
      "refunded": "Refunded",
      "net": "Net GMV"
    },
    "toast": {
      "exportSuccessTitle": "Export job created",
      "exportSuccessDesc": "An email will be sent when it's ready (~{{seconds}}s).",
      "exportFailTitle": "Could not create export"
    }
  },
  "leaderboard": {
    "title": "Seller Leaderboard",
    "subtitle": "Top {{topN}} sellers by GMV. Materialized view refreshes every 10 min; admins can force refresh (rate limit 2 times / 5 min).",
    "refreshNow": "Refresh now",
    "periodAria": "Period",
    "podiumAria": "Top 3",
    "podiumEmpty": "No data for this period.",
    "gmv": "GMV",
    "dealsWon": "Deals won",
    "period": {
      "month": "Month",
      "quarter": "Quarter",
      "all_time": "All time"
    },
    "table": {
      "rank": "#",
      "saler": "Seller",
      "gmv": "GMV",
      "dealsWon": "Deals won",
      "empty": "No sellers beyond the podium."
    },
    "toast": {
      "refreshSuccessTitle": "Leaderboard refreshed",
      "refreshSuccessDesc": "{{count}} rows updated.",
      "refreshFailTitle": "Could not refresh"
    }
  },
  "myPerformance": {
    "heading": "My performance",
    "subtitle": "Track your personal GMV, targets and conversion rate per period.",
    "loadError": "Failed to load data.",
    "periodAria": "Period",
    "periods": {
      "monthly": "This month",
      "quarterly": "This quarter",
      "semi": "Half-year",
      "annual": "Year"
    },
    "kpiAria": "KPI",
    "kpi": {
      "targetGmv": "Target GMV",
      "currentGmv": "Current GMV",
      "progress": "Progress",
      "overallConversion": "Overall conversion rate"
    },
    "progress": {
      "aria": "Progress vs target",
      "title": "Progress vs target",
      "detail": "{{current}} / {{target}} (through {{date}})",
      "empty": "No target configured for this period."
    },
    "funnel": {
      "aria": "Conversion funnel",
      "title": "Conversion funnel",
      "empty": "No funnel data for this period."
    }
  },
  "myProfile": {
    "loading": "Loading profile",
    "loadError": "Unable to load profile.",
    "heading": "My profile",
    "subtitle": "Your contact details, email signature and notification preferences.",
    "validation": {
      "minChars": "At least {{count}} characters",
      "maxChars": "At most {{count}} characters",
      "invalidUrl": "Invalid URL"
    },
    "toast": {
      "savedTitle": "Saved",
      "savedDesc": "Profile updated.",
      "saveFailTitle": "Save failed"
    },
    "basic": {
      "title": "Basic information",
      "emailLabel": "Email",
      "emailNote": "cannot be changed here — contact admin if needed.",
      "name": "Full name",
      "phone": "Phone number",
      "phonePlaceholder": "+84 ...",
      "avatarUrl": "Avatar URL",
      "avatarHelp": "PNG/JPG, up to 2MB. FileUploadInput coming in a later wave; paste the URL directly for now.",
      "signatureLabel": "Email signature (up to {{count}} characters)",
      "signatureHelpPrefix": "Use ",
      "signatureHelpSuffix": " to auto-insert the sender's name."
    },
    "notifications": {
      "title": "Notification preferences",
      "desc": "Changes apply to the next dispatch.",
      "followUp": "Follow-up reminder notification",
      "dealExpire": "Deal expiring soon notification",
      "digestLabel": "Periodic digest",
      "digest": {
        "off": "Off",
        "daily": "Daily",
        "weekly": "Weekly"
      }
    },
    "ics": {
      "title": "ICS calendar",
      "desc": "Regenerate the ICS calendar URL if you suspect a leak. The old URL stays valid for 7 days after regeneration."
    },
    "save": {
      "saving": "Saving…",
      "submit": "Save changes"
    }
  },
  "overview": {
    "heading": "Sales Overview",
    "subtitle": "Overview of leads, deals, targets and today's activity.",
    "loadError": "Failed to load data.",
    "kpiAria": "KPI",
    "cards": {
      "leads-today": "Leads today",
      "deals-expiring": "Deals expiring soon",
      "target-progress": "Monthly target progress",
      "activity-today": "Activity today"
    },
    "leaderboard": {
      "aria": "Leaderboard",
      "title": "Top 10 Salers",
      "periods": {
        "month": "Month",
        "quarter": "Quarter",
        "all_time": "All time"
      },
      "columns": {
        "rank": "Rank",
        "saler": "Saler",
        "gmv": "GMV",
        "dealsWon": "Deals won"
      },
      "empty": "No leaderboard data yet."
    },
    "activity": {
      "aria": "Activity",
      "label": "Activity:",
      "loadError": "Failed to load activity data.",
      "title": "Recent activity",
      "subtitle": "Last 30 days — up to 50 events.",
      "empty": "No activity yet."
    }
  },
  "targets": {
    "heading": "Seller KPI Targets",
    "subtitle": "Manage GMV targets per period — admin/manager can create and inline-edit.",
    "exportCsv": "Export CSV",
    "newTarget": "New target",
    "periodAria": "Period",
    "periods": {
      "all": "All",
      "monthly": "Month",
      "quarterly": "Quarter",
      "semi": "Half-year",
      "annual": "Year"
    },
    "columns": {
      "saler": "Seller",
      "period": "Period",
      "range": "Range",
      "targetGmv": "Target GMV",
      "current": "Current",
      "achieved": "% Achieved"
    },
    "empty": "No targets for this period yet.",
    "rowActions": {
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit"
    },
    "toast": {
      "createdTitle": "Target created",
      "createdDesc": "KPI target saved successfully.",
      "createFailTitle": "Failed to create target",
      "updatedTitle": "Target updated",
      "updateFailTitle": "Update failed",
      "exportTitle": "Export job created",
      "exportDesc": "Email will be sent on completion (~{{eta}}s).",
      "exportFailTitle": "Failed to create export",
      "invalidValueTitle": "Invalid value",
      "invalidValueDesc": "Target must be a positive number."
    },
    "modal": {
      "aria": "Create new KPI target",
      "title": "Create KPI target",
      "salerLabel": "Seller",
      "salerPlaceholder": "Find seller by name / email…",
      "periodLabel": "Period",
      "startLabel": "Start",
      "endLabel": "End",
      "gmvLabel": "Target GMV (USD)",
      "cancel": "Cancel",
      "create": "Create"
    }
  }
}
